import React, { useState } from 'react';
import constClass from '../../Constants/Constants';
import BackyardOrder from './BackyardOrder'
import BackyardOrderFin from './BackyardOrderFin';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Common from '../Common/common.js';
 
const BackyardOrderFinTab = (props) => {
  const { settings } = props;
  const statusIndex = (status) => {
    if(status === constClass.STATUS.REG){
      return 0;
    }else if(status === constClass.STATUS.FIN){
      return 1;
    } else if(status === constClass.STATUS.CCL) {
      return 2;
    } else if(status === constClass.STATUS.ABS) {
      return 3;
    }
    // if(status === constClass.STATUS.FIN){
    //   return 1;
    // } else if(status === constClass.STATUS.CCL) {
    //   return 2;
    // } else if(status === constClass.STATUS.ABS) {
    //   return 3;
    // }
  };
  const [index, setIndex] = useState(statusIndex(props.sts));
  const handleTabSelect = (idx, lastIndex, e) => {
    setIndex(idx);
    return true;
  }

  return (
    <div className="container">
      <Tabs onSelect={handleTabSelect}>
        <TabList className="nav nav-pills mb-2">
          <Tab className="nav-item"><button className={`nav-link nav-btn ${index === 0 ? 'active' : ''}`}>発券</button></Tab>
          <Tab className="nav-item"><button className={`nav-link nav-btn ${index === 1 ? 'active' : ''}`}>{Common.getSettingValue(settings, 'LABEL_STATUS_ABS')}</button></Tab>
          <Tab className="nav-item"><button className={`nav-link nav-btn ${index === 2 ? 'active' : ''}`}>{Common.getSettingValue(settings, 'LABEL_STATUS_FIN')}</button></Tab>
          <Tab className="nav-item"><button className={`nav-link nav-btn ${index === 3 ? 'active' : ''}`}>{Common.getSettingValue(settings, 'LABEL_STATUS_CCL')}</button></Tab>
          {/* <Tab className="nav-item"><a className={`nav-link ${index === 0 ? 'active' : ''}`} href="#">完了一覧</a></Tab>
          <Tab className="nav-item"><a className={`nav-link ${index === 1 ? 'active' : ''}`} href="#">取消一覧</a></Tab>
          <Tab className="nav-item"><a className={`nav-link ${index === 2 ? 'active' : ''}`} href="#">不在一覧</a></Tab> */}
        </TabList>
        <TabPanel>
          <BackyardOrder {...props} />
        </TabPanel>
        <TabPanel>
          <BackyardOrderFin statusIdx={index} {...props} />
        </TabPanel>
        <TabPanel>
          <BackyardOrderFin statusIdx={index} {...props} />
        </TabPanel>
        <TabPanel>
          <BackyardOrderFin statusIdx={index} {...props} />
        </TabPanel>
      </Tabs>
    </div>
  )
}

export default BackyardOrderFinTab;